import { ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface PasswordRecoveryState extends ApiState { }

export default requestReducer<PasswordRecoveryState>('PASSWORD_RECOVERY')

